import React, { useState, useEffect } from 'react'
import bdLogo from '../../../public/Bitmap.png'
import spinner from '../../../public/Spinner.gif'
const delay = 5

export default function SubscriptionRenewSuccess() {
  async function getSubscriptionData() {
    const customerId = sessionStorage.getItem('cachedCustomerId')
    console.log(customerId)

    const options = {
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_STRIPE_SECRET_LIVE}`,
      },
    }

    const url = `https://api.stripe.com/v1/subscriptions?customer=${customerId}&status=all`

    const response = await fetch(url, options)
    let subscription

    if (response.ok === false) {
      subscription = false
    } else {
      const json = await response.json()
      subscription = json.data[0]
      console.log(subscription)
    }

    if (subscription) {
      if (subscription.ended_at === null) {
        const cachedUrl = sessionStorage.getItem('cachedRoomUrl')
        window.location.replace(cachedUrl)
      } else {
        console.log('Not resubscribed yet')
      }
    }
  }

  useEffect(() => {
    let timer = setTimeout(() => getSubscriptionData(), delay * 1000)

    return () => {
      clearTimeout(timer)
    }
  }, [])
  return (
    <div className='subscription-success-container'>
      <div className='nav-bar'>
        <a
          href='https://branding.cards'
          alt='bd-logo'
          className='bd-logo-container'
        >
          <img className='bd-logo' src={bdLogo} alt='Brand Deck Logo' />
        </a>
        <div className='back-link-container'>
          <a className='back-link' href='https://branding.cards'>
            Back to Branding.Cards
          </a>
        </div>
      </div>

      <div className='subscription-success-render'>
        <img
          className='subscription-success-image'
          src={spinner}
          alt='spinner'
        />
        <div className='not-found-text'>
          <div>You have successfully subscribed to Brand Deck.</div>
          <div>Please wait while you are redirected.</div>
        </div>
      </div>
    </div>
  )
}
